import { useEffect, useState } from 'react';
import Responsive from '../modules/Responsive';

export const useIsMobile: () => boolean = () => {
  const [isMobile, setMobile] = useState(Responsive.is.mobile || Responsive.is.tablet);

  useEffect(() => {
    const subscription = Responsive.changeStream.subscribe((is) => {
      setMobile(is.mobile || is.tablet);
    });

    return () => {
      subscription.dispose();
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
